import { MobXProviderContext } from "mobx-react";
import { useContext } from "react";

export const useStore = (type)=>useContext(MobXProviderContext)[type]